import script from "./ImigrationReportFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ImigrationReportFilter.vue?vue&type=script&setup=true&lang=js"

import "./ImigrationReportFilter.vue?vue&type=style&index=0&id=3b67f371&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b67f371"]])

export default __exports__